import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/app/auth-context'
import { AppRoutes } from '@/app/routes'
import { EntryZoneTitle } from '@/app/entry-zone'

/**
 * Корень SPA «Центрика»: провайдер сессии + маршрутизация кабинета (Блок 1 — каркас и вход).
 * Экраны и сшивка с API — в src/app и src/pages; дизайн-система используется как есть.
 */
export function App() {
  return (
    <AuthProvider>
      {/* Кабинет сотрудников (внутренний адрес) — своё название вкладки. */}
      <EntryZoneTitle />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}
